export const LIST = "SELECTIVE_MEMBER_POP_OUT_LIST";
export const UPDATE_STATUS = "SELECTIVE_MEMBER_POP_OUT_UPDATE";
export const STORE = "SELECTIVE_MEMBER_POP_OUT_STORE";